import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatStepperModule} from '@angular/material/stepper';
import {MatCardModule} from '@angular/material/card';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgOtpInputModule } from  'ng-otp-input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ClipboardModule } from 'ngx-clipboard';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {MatRippleModule} from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LibModule } from '../lib/lib.module';
import {MatSliderModule} from '@angular/material/slider';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { PostHubRoutingModule } from './post-hub-routing.module';
import { PostListComponent } from './post-list/post-list.component';
import { MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { PostDetailComponent } from './post-detail/post-detail.component';
import { CreatePost } from './create-post/create-post.component';
import { AddVideoLink } from './create-post/create-post.component';
@NgModule({
    declarations: [
        PostListComponent,
        PostDetailComponent,
        CreatePost,
        AddVideoLink
    ],
    imports: [
        CommonModule,
        PostHubRoutingModule,
        MatStepperModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatIconModule,
        MatInputModule,
        MatSlideToggleModule,
        NgOtpInputModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatSelectModule,
        MatRadioModule,
        MatCheckboxModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        ClipboardModule,
        TooltipModule,
        MatRippleModule,
        NgbModule,
        LibModule,
        MatSliderModule,
        MatDatepickerModule,
        MatMenuModule,
        MatButtonModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PostHubModule { }
